import { SCI_HEAT } from "@/lib/science/sci-chart";
import { PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE =
  "Gene,Sample 1,Sample 2,Sample 3,Sample 4\nGeneA,12,45,30,8\nGeneB,50,22,15,40\nGeneC,5,18,60,33\nGeneD,28,35,10,52";

export function HeatmapPlot() {
  return (
    <PlotShell
      toolId="heatmap"
      inputLabel={m.plot_input_label()}
      placeholder={m.heat_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => {
        const cells: [number, number, number][] = [];
        let min = Infinity;
        let max = -Infinity;
        data.matrix.forEach((row, r) => {
          row.forEach((val, c) => {
            if (Number.isFinite(val)) {
              cells.push([c, r, val]);
              min = Math.min(min, val);
              max = Math.max(max, val);
            }
          });
        });
        if (!Number.isFinite(min)) {
          min = 0;
          max = 1;
        }
        return {
          tooltip: { position: "top" },
          grid: { left: 90, right: 20, top: 20, bottom: 70 },
          xAxis: {
            type: "category",
            data: data.colHeaders,
            splitArea: { show: true },
            axisLabel: {
              color: theme.muted,
              fontSize: 10,
              rotate: data.colHeaders.length > 6 ? 30 : 0,
            },
            axisLine: { lineStyle: { color: theme.border } },
          },
          yAxis: {
            type: "category",
            data: data.rowLabels,
            splitArea: { show: true },
            axisLabel: { color: theme.muted, fontSize: 10 },
            axisLine: { lineStyle: { color: theme.border } },
          },
          visualMap: {
            min,
            max,
            calculable: true,
            orient: "horizontal",
            left: "center",
            bottom: 0,
            inRange: { color: SCI_HEAT },
            textStyle: { color: theme.muted },
          },
          series: [
            {
              type: "heatmap",
              data: cells,
              label: { show: cells.length <= 60, color: "#fff", fontSize: 9 },
              emphasis: {
                itemStyle: { shadowBlur: 8, shadowColor: "rgba(0,0,0,0.4)" },
              },
            },
          ],
        };
      }}
    />
  );
}
